import React, { Component } from "react";
import Toast from '../components/Toast';
import TopMenu from "../components/TopMenu";
import UserManagement from "../components/UserManagement";

class UserManagementLayout extends Component {

  render() {
    return (
      <div className="settings-page">
        <TopMenu />
        <UserManagement />
				<Toast />
      </div>
    );
  }
}

export default UserManagementLayout;
